/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class s{constructor(s,t=JSON.stringify(s)){this.inner=s,this.hash=t}}export{s as Hashed};
